import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { TranslocoLoader } from '@jsverse/transloco';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private readonly http = inject(HttpClient);

  getTranslation(culture: string): Observable<Record<string, string>> {
    const scope = environment.shellScope;
    return this.http.get<Record<string, string>>(
      `${environment.apiBaseUrl}/api/v1/platform/localization/resources?culture=${culture}&scope=${scope}`);
  }
}
